module.exports = __webpack_public_path__ + "media/svg/sv-e21cb2b7.svg";